import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            探索知识分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            选择你感兴趣的主题，获取专业、科学的性健康知识
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 hover:bg-primary-50 rounded-2xl p-6 text-center transition-all duration-300 cursor-pointer border border-background-200/70 hover:border-primary-200"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100 group-hover:bg-primary-200 flex items-center justify-center transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-700 mb-2">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}